<template>
    <div :class="[$style.select, {[$style['is-selected']]: isSelected}, {[$style['select_theme_white']]: isConstant}]"
         v-if="select"
         ref="select">
        <div :class="[$style['select__fake'],{[$style['is-disabled']]: select.disabled}, {[$style['is-open']]: isOpen}]">
            <div :class="$style['select__fake-current']" @click="toggleOpen">
                <span :class="$style['select__fake-current-text']">{{ selectedItem.text }}</span>
                <span :class="$style['select__fake-arrow']">
                    <svg width="10"
                         height="6"
                         viewBox="0 0 10 6"
                         fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L5 5L9 1" stroke="#ffffff"/></svg>
                </span>
            </div>

            <div v-if="isMobile && isOpen" :class="$style['select__fix']" ref="fixedList">
                <div :class="$style['select__fix-top']">
                    <div :class="[$style['select__fix-label'], 'h4']">{{ label }}</div>
                    <div :class="$style['select__fix-close']" @click="closeFixedList">
                        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="32" height="32" fill="#22242B"/>
                            <path d="M16 15.3685L10.6316 10L10 10.6316L15.3685 16L10.0001 21.3684L10.6316 22L16 16.6316L21.3684 21.9999L21.9999 21.3683L16.6316 16L22 10.6317L21.3684 10.0001L16 15.3685Z"
                                  fill="white"/>
                        </svg>
                    </div>
                </div>

                <div :class="$style['select__fix-content']">
                    <ul :class="[$style['select__fake-list'], $style['select__fake-list_mobile']]"
                        :style="{maxHeight: heightList}"
                        ref="list">
                        <li v-for="option in select.options"
                            :key="option.id"
                            :value="option.value"
                            :class="{[$style['selected']]: option.selected}"
                            @click="change(option)"
                        >
                            {{ option.text }}
                            <Tooltip v-if="option.tooltip && option.tooltip.text"
                                     :class="$style['select__fake-list-tooltip']">
                                {{ option.tooltip.text }}
                            </Tooltip>
                            <span v-if="option.description" :class="$style['select__description']">{{ option.description }}</span>
                            <span v-if="option.pass === false" :class="$style['select__no-result']">Нет результатов</span>
                        </li>
                    </ul>
                </div>

                <div :class="$style['select__fix-submit']" @click="closeFixedList">Применить</div>
            </div>

            <ul v-if="!isMobile"
                :class="[$style['select__fake-list'], $style['select__fake-list-desc'], {[$style['is-open']]: isOpen}]"
                :style="{maxHeight: heightList}"
                ref="list">
                <li v-for="option in select.options"
                    :key="option.id"
                    :value="option.value"
                    :class="{[$style['selected']]: option.selected}"
                    @click="change(option)"
                >
                    {{ option.text }}
                    <Tooltip v-if="option.tooltip && option.tooltip.text"
                             :class="$style['select__fake-list-tooltip']">
                        {{ option.tooltip.text }}
                    </Tooltip>

                    <span v-if="option.description" :class="$style['select__description']">{{ option.description }}</span>
                    <span v-if="option.pass === false" :class="$style['select__no-result']">Нет результатов</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Tooltip from '../../Tooltip/Tooltip';
    import Button from '../../Button/Button';
    import Utils from '../../../helpers/Utils';

    export default {
        components: {
            Button,
            Tooltip
        },

        props: ['filter', 'select', 'slug', 'noSelected', 'label'],

        data() {
            return {
                isOpen    : false,
                heightList: 0,
                isMobile  : window.innerWidth < 960,
            }
        },

        computed: {
            selectedItem() {
                return this.select.options.find(option => option.selected) || this.select.options[0];
            },

            isSelected() {
                return this.select.options.filter((option) => {
                    return option.selected && option !== this.select.options[0];
                }).length;
            },

            isConstant() {
                return this.slug === 'tabs';
            }
        },

        methods: {
            change(option) {
                if (this.select.disabled) {
                    return;
                }

                // Проверка на наличие результатов по выбранному табу (для типа ипотеки)
                let isResult = 0;

                if (!this.noSelected && isResult !== -1) {
                    this.setCurrent(option);
                }

                this.$emit('change', this.slug, option);
                !this.isMobile && this.hideList();
            },

            setCurrent(option) {
                this.select.options.forEach((item) => {
                    item.selected = item === option;
                });
            },

            toggleOpen() {
                if (this.select.disabled) {
                    return;
                }

                if (this.isMobile) {
                    this.isOpen = true;
                    Utils.bodyFixed(this.$refs.fixedList);

                    return;
                }

                if (this.isOpen) {
                    this.hideList();
                } else {
                    this.showList();
                }
            },

            hideList() {
                this.isOpen = false;
                this.heightList = '0px';
            },

            showList() {
                this.isOpen = true;
                this.heightList = `${this.getHeightList()}px`;
            },

            getHeightList() {
                return this.$refs.list.scrollHeight;
            },

            setHeightOnResize() {
                if (this.isOpen) {
                    this.heightList = `${this.getHeightList()}px`;
                }
            },

            clickOutside() {
                const target = event.target;
                const selectWrapper = this.$refs.select;

                if (!this.isDescendant(selectWrapper, target)) {
                    this.hideList();
                }
            },

            isDescendant(parent, child) {
                let node = child.parentNode;

                while (node != null) {
                    if (node.classList && node.classList.contains('vue-tooltip')) {
                        return true;
                    }
                    if (node === parent) {
                        return true;
                    }

                    node = node.parentNode;
                }

                return false;
            },

            closeFixedList() {
                Utils.bodyStatic();
                this.isOpen = false;
            },

            resize() {
                this.setHeightOnResize();
                this.isMobile = window.innerWidth < 960;
            }
        },

        mounted() {
            window.addEventListener('resize', this.resize);
            document.body.addEventListener('click', this.clickOutside, false);
        },

        destroyed() {
            window.removeEventListener('resize', this.resize);
            document.body.removeEventListener('click', this.clickOutside, false);
        }
    }
</script>

<style lang="scss" module>
    @import "./SingleSelect";
</style>
